import React from 'react';
import { useLocation } from 'react-router-dom';

// Thin red line across the top of the screen on every page change, so navigation feels
// acknowledged. Keying on the path remounts the bar, which replays the CSS animation.
const RouteProgress = () => {
    const { pathname } = useLocation();

    return (
        <div
            key={pathname}
            className="pointer-events-none fixed inset-x-0 top-0 z-[1000] h-[3px] bg-[#D81F26] shadow-[0_0_8px_rgba(216,31,38,0.45)] animate-dash-route-progress"
            aria-hidden="true"
        />
    );
};

export default RouteProgress;
